import { ChangeDetectionStrategy, Component, input, type InputSignal } from '@angular/core';
import { UiDisclosurePanelComponent } from '@nexus/frontend-shared-ui';
import type { WishlistDetailPanelView } from '../../types/wishlist-detail-panel-view.interface';
import { WishlistProgressSummaryComponent } from '../wishlist-progress-summary/wishlist-progress-summary.component';

@Component({
  selector: 'wishlist-detail-side-panels',
  imports: [UiDisclosurePanelComponent, WishlistProgressSummaryComponent],
  templateUrl: './wishlist-detail-side-panels.component.html',
  styleUrl: './wishlist-detail-side-panels.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistDetailSidePanelsComponent {
  public readonly panels: InputSignal<readonly WishlistDetailPanelView[]> =
    input.required<readonly WishlistDetailPanelView[]>();
}
